import React, { useEffect, useState } from 'react';
import { Root,
    CheckboxContainer,
    HiddenCheckbox,
    StyledCheckbox,
    Icon,
    Label
} from './styles';

export interface IState {}

export interface IProps {
    label: string;
    type:string;
    onChange: (value:any,type: string, add: boolean) => void;
    checked?: boolean;
    styleRoot?: any;
    styledCheckbox?: any;
    styleLabel?: any;
    stroke?: any;
}

const Filter:React.FC<IProps> = (props) => {
  const [checked, setChecked]=useState(false);

  const handleCheckboxChange = (evt:React.ChangeEvent<HTMLInputElement>) => {
    setChecked(evt.currentTarget.checked)
    props.onChange(props.label, props.type, evt.currentTarget.checked);
  };

  useEffect(() => {
    if(props.checked!=undefined)setChecked(props.checked);
  }, [props.checked]);
  
  return (
    <Root style={props.styleRoot}>
      <CheckboxContainer className=''>
        <HiddenCheckbox checked={checked} onChange={(evt)=>handleCheckboxChange(evt)}/>
        <StyledCheckbox checked={checked} style={props.styledCheckbox}>
          <Icon viewBox="0 0 24 24" stroke={props.stroke}>
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
      </CheckboxContainer>
      <Label style={props.styleLabel}>{props.label}</Label>
    </Root>
  );
}

export default Filter;